import { render } from "./HorseEditing.vue?vue&type=template&id=1321e934&scoped=true&ts=true"
import script from "./HorseEditing.vue?vue&type=script&lang=ts"
export * from "./HorseEditing.vue?vue&type=script&lang=ts"

import "./HorseEditing.vue?vue&type=style&index=0&id=1321e934&scoped=true&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1321e934"]])

export default __exports__